import styled, { css } from 'styled-components';

import { basicCaptionTextStyle, Dropdown, Text } from '@dreryk/react-components';

export const StyledUserDropdown = styled(Dropdown)`
   ${Dropdown.resolveFloatingNodeStyles(css`
      max-height: 276px;
   `)}
`;

StyledUserDropdown.displayName = 'StyledUserDropdown';

export const StyledText = styled(Text)`
   ${basicCaptionTextStyle};
   color: ${(props) => props.theme.background};
`;

StyledText.displayName = 'StyledText';
